import React from 'react'
import { UseFormReturn } from 'react-hook-form';
import { MasterMedicine } from '../../../../apis/master-medicines/types';
import CreateMasterMedicine from './CreateMasterMedicine';
import SaveMasterMedicine from './SaveMasterMedicine';

interface Props {
  form: UseFormReturn<MasterMedicine>;
  id?: string;
}

const CreateSaveMasterMedicineButton = ({ form, id }: Props) => {
  if (!id) {
    return <CreateMasterMedicine form={form} />;
  }

  return <SaveMasterMedicine id={id} form={form} />;
};
export default CreateSaveMasterMedicineButton;
